// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"81":"5972abdb00a47ad7d9c6","510":"4f066c7e61fed31c84ba","595":"7997f1820d1c4dbddea5","671":"8a9f1517dd8e1381831d"}[chunkId] + ".js";
};